const axios = require("axios");
const BACK_API_URL = "/Newback";
const AUTH_URI = "/moduleCore/auth/login";

export const login = (data, fnSuccess, fnError=()=>{}) => {
console.log("BACK_API_URL", BACK_API_URL);
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: BACK_API_URL+AUTH_URI,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };

  axios
    .request(config)
    .then((response) => {
      fnSuccess(response.data);
    })
    .catch((error) => {
      console.log(error);
      fnError(error);
    });
};
